import { FormsLangToLegalConsentLangMap } from 'forms-utils-lib/language/LanguageConstants';
import { getFormsLangToLangMap } from 'forms-utils-lib/language/getFormsLangToLangMap';
export const formsLangToLegalConsentLang = getFormsLangToLangMap(FormsLangToLegalConsentLangMap);